import request from '@/utils/request.js'
import qs from 'qs';

export function getImportRecordList(data) {
    return request({
        url: 'sim/importRecord/listPage',
        method: 'post',
        data
    })
}

export function getImportFailRecordList(data) {
    return request({
        url: 'sim/importFail/listPage',
        method: 'post',
        data
    })
}

export function getAdminCardList(data) {
    return request({
        url: 'sim/admin/listPage',
        method: 'post',
        data
    })
}

export function getAgentCardList(data) {
    return request({
        url: 'sim/agent/listPage',
        method: 'post',
        data
    })
}
/*****单卡导入******/
export function oneCardImport(data) {
    return request({
        url: 'sim/import/one',
        method: 'post',
        headers: {
            'content-type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify(data)
    })
}
export function simDistribut(data) {
    return request({
        url: 'sim/soldList',
        method: 'post',
        data
    })
}

/** 卡片导出 */
export function exportSimInfo(data) {
    return request({
        url: 'export/simInfo',
        method: 'post',
        data
    })
}

/** 消费列表导出 */
export function exportConsumptionList(data) {
    return request({
        url: 'export/simPriceDataDetail',
        method: 'post',
        data
    })
}

/***卡片详情***/
export function getSimDetailInfo(data) {
    return request({
        url: 'sim/detail',
        method: 'post',
        data
    })
}

/***平台获取套餐列表***/
export function getPkgList(data) {
    return request({
        url: 'sim/admin/soldPkg',
        method: 'get',
        params: data
    })
}
/***代理商获取套餐列表***/
export function getAgentPkgList(data) {
    return request({
        url: 'sim/agent/soldPkg',
        method: 'get',
        params: data
    })
}

/***平台添加套餐***/
export function addPkg(data) {
    return request({
        url: 'order/pkgOrder/admin/add',
        method: 'post',
        headers: {
            'content-type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify(data)
    })
}
/***代理商添加套餐***/
export function agentAddPkg(data) {
    return request({
        url: 'order/pkgOrder/agent/add',
        method: 'post',
        headers: {
            'content-type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify(data)
    })
}

/***往期订单***/
export function getOneSIMOrderList(data) {
    return request({
        url: 'order/pkgOrder/sim/listPage',
        method: 'post',
        data
    })
}

/***分销记录***/
export function getSimDistributRecord(data) {
    return request({
        url: 'sim/soldRecord/listPage',
        method: 'post',
        data
    })
}

/***SIM卡分销失败记录***/
export function getSimDistributFailRecordList(data) {
    return request({
        url: 'sim/soldFail/listPage',
        method: 'post',
        data
    })
}

/***获取可变更的套餐组***/
export function getAllowChangePkgGroup(data) {
    return request({
        url: 'sim/change/allow/pkgGroup',
        method: 'get',
        params: data
    })
}

/***变更套餐组***/
export function toChangePkgGroup(data) {
    return request({
        url: 'sim/change/pkgGroup',
        method: 'post',
        data: qs.stringify(data)
    })
}

/***卡片回收***/
export function simRecovery(data) {
    return request({
        url: 'sim/recoverList',
        method: 'post',
        data
    })
}

/***指定过期时间 变更套餐***/
export function changePkgEndTime(data) {
    return request({
        url: 'sim/pkg/endTime',
        method: 'post',
        data
    })
}
/***指定延长时间 变更套餐***/
export function delayPkgEndTime(data) {
    return request({
        url: 'sim/pkg/endTimeByDay',
        method: 'post',
        data
    })
}
/***转新卡***/
export function toNewCard(data) {
    return request({
        url: 'sim/pkg/move',
        method: 'post',
        data: qs.stringify(data)
    })
}
/***一键诊断***/
export function simDiagnosis(data) {
    return request({
        url: 'sim/update/stateRateFlow',
        method: 'post',
        data: qs.stringify(data)
    })
}
/***更新状态***/
export function updateState(data) {
    return request({
        url: 'sim/select/stateRateFlow',
        method: 'post',
        data: qs.stringify(data)
    })
}
/***保号停机***/
export function stopSim(data) {
    return request({
        url: 'sim/stop',
        method: 'post',
        data: qs.stringify(data)
    })
}
/***保号复机***/
export function resetSim(data) {
    return request({
        url: 'sim/restart',
        method: 'post',
        data: qs.stringify(data)
    })
}
/***保号复机***/
export function resetSimss(data) {
    return request({
        url: 'sim/to/active',
        method: 'post',
        data
    })
}
/***停复机记录***/
export function getSimStopStartRecordList(data) {
    return request({
        url: 'sim/stopStartRecord/all/listPage',
        method: 'post',
        data
    })
}
export function getSimStopStartRecordLists(data) {
    return request({
        url: 'applyChangeSim/user/lottery/records',
        method: 'post',
        data
    })
}
/***老卡转新卡记录***/
export function getOldToNewList(data) {
    return request({
        url: 'sim/changeRecord/listPage',
        method: 'post',
        data
    })
}
/***流量使用详情***/
export function getFluxDetailList(data) {
    return request({
        url: 'sim/realRate/listPage',
        method: 'post',
        data
    })
}
/***获取卡片状态字典***/
export function getCardStateDict(data) {
    return request({
        url: 'sim/state/dict',
        method: 'get',
        params: data
    })
}
/***批量操作列表***/
export function getBatchOptList(data) {
    return request({
        url: 'import/sim/state/list',
        method: 'post',
        data
    })
}
export function smokeAdd(data) {
    return request({
        url: 'smoke/stock/add',
        method: 'post',
        data
    })
}
export function smokeList(data) {
    return request({
        url: 'smoke/stock/listPage',
        method: 'post',
        data
    })
}
export function smokeSoldList(data) {
    return request({
        url: 'smoke/naxt/agent/list',
        method: 'post',
        data
    })
}
export function updatesmokeList(data) {
    return request({
        url: 'smoke/stock/update',
        method: 'post',
        data
    })
}
export function smokeLogList(data) {
    return request({
        url: 'smoke/stock/log/listPage',
        method: 'post',
        data
    })
}
/***流量轮询记录列表***/
export function getFluxPollList(data) {
    return request({
        url: 'pollingRecord/list',
        method: 'post',
        data
    })
}

/***查询轮询记录明细***/
export function getFluxPollDetail(data) {
    return request({
        url: 'pollingRecord/list/detail',
        method: 'post',
        data
    })
}

/** 导出轮询记录明细 **/
export function exportFluxPollDetail(data) {
    return request({
        url: 'export/exportPolliingRecordDetail',
        method: 'post',
        data
    })
}


/***批量操作失败列表***/
export function getBatchOptFailList(data) {
    return request({
        url: 'import/sim/state/fail/list',
        method: 'post',
        data
    })
}
/***批量变更状态***/
export function batchChgState(data) {
    return request({
        url: 'import/sim/state/import/sim/state',
        method: 'post',
        data: qs.stringify(data)
    })
}

/***批量充值记录***/
export function getBgdRechargeList(data) {
    return request({
        url: 'sim/investPkg/record/listPage',
        method: 'post',
        data
    })
}
/***批量充值失败记录***/
export function getBgdRechargeFailList(data) {
    return request({
        url: 'sim/investPkg/fail/listPage',
        method: 'post',
        data
    })
}
/***单卡改状态***/
export function changeCardState(data) {
    return request({
        url: 'batch/change/piece/sim/state',
        method: 'post',
        data
    })
}
/***绑定手机记录列表***/
export function getBindPhoneList(data) {
    return request({
        url: 'bindPhone/query/list',
        method: 'post',
        data
    })
}
/***代理商获取某一个套餐组下的套餐***/
export function getPkgListOfGroup(data) {
    return request({
        url: 'sim/investPkg/allow/list',
        method: 'get',
        params: data
    })
}
/***查询叠加包套餐组***/
export function getOverlayPkgOptions(data) {
    return request({
        url: 'pkg/group/append/list',
        method: 'post',
        data
    })
}

/***  导出绑定手机记录列表  ***/
export function exportRecord(data) {
    return request({
        url: 'export/simBindPhone',
        method: 'post',
        data
    })
}

/***  导出sim卡变更状态列表  ***/
export function exportSimChangeStateFail(data) {
    return request({
        url: 'export/simChangeStateFail',
        method: 'post',
        data
    })
}

/***  按套餐过期时间查询SIM卡信息  ***/
export function getSimInfoByEndTime(data) {
    return request({
        url: 'sim/noEnd/ListPage',
        method: 'post',
        data
    })
}

/** 过期SIM卡导出 */
export function exportSimNoEndInfo(data) {
    return request({
        url: 'export/simNoEnd',
        method: 'post',
        data
    })
}


/** 老卡转新卡导出 */
export function exportChangeSimRecord(data) {
    return request({
        url: 'export/changeSimRecord',
        method: 'post',
        data
    })
}

/** 单卡修改sim卡流量比 */
export function sureChgFlowRateSingle(data) {
    return request({
        url: 'sim/change/flowRatePercent',
        method: 'post',
        data
    })
}



/** 微信地址导出 */
export function exportSimWxAddress(data) {
    return request({
        url: 'export/simWxAddress',
        method: 'post',
        data
    })
}


// 删除绑定手机记录
export function deleteBindRecord(data) {
    return request({
        url: 'bindPhone/delete',
        method: 'post',
        data,
    })
}

// 轮询不停机列表
export function pollingNotStopList(data) {
    return request({
        url: 'batch/change/no/stop/sim',
        method: 'post',
        data,
    })
}

// 轮询列表操作
export function deletePollingNotStop(data) {
    return request({
        url: 'batch/change/del/stop/sim',
        method: 'post',
        data,
    })
}

// 轮询清空
export function clearDataHandle(data) {
    return request({
        url: 'batch/change/batch/del/stop/sim',
        method: 'post',
        data,
    })
}

/***消费情况 */
export function getUseData(data) {
    return request({
        url: 'sim/useData/price',
        method: 'post',
        data,
    })
}

